import { create } from 'zustand';
import { getState, useState } from '@/framework';
import { IDragData, IExportState, StateType } from '@/version-types';

/** 状态 */
interface IState {
    /** 拖拽内容 */
    dragData: IDragData | null;
}

/** 动作 */
interface IAction {
    /** 设置拖拽内容 */
    setDragData: (dragData: IDragData | null) => void;
}

/** 存储类型 */
interface IStore extends IState, IAction {}

/** 初始化状态 */
function getInitialState() {
    return {
        dragData: null,
    };
}

/** 创建存储 */
const createState = (identity: string) => {
    const store = create<IStore>((set, get) => ({
        ...getInitialState(),

        setDragData(dragData) {
            set({ dragData });
        },
    }));

    return store;
};

/** 存储名称 */
const name = 'drag-layer-state';

/** 存储类型 */
type ModuleType = StateType<IStore, typeof name>;

/** hook 获取存储 */
export const useDragLayerState = () => {
    return useState<ModuleType>()[name];
};

/** 通过 id 获取存储 */
export const getDragLayerState = (identity: string) => {
    return getState<ModuleType>(identity)[name].getState();
};

const exportState: IExportState = {
    name,
    createState,
};

export default exportState;
